// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"d4720c94","624":"a0cedca2"}[chunkId] + ".chunk.css";
};